<template>
  <div id="container" style="display: flex; align-items: left">
    <b-select
      v-model="citySelector"
      size="lg"
      class="city-select m-1"
      v-show="
        $store.state.parameterStripe.modelType == 'city' &&
        $store.state.parameterStripe.viewType == 'graphView'
      "
      @change="citySelect"
    >
      <option value="BPK00">Budapest</option>
      <option value="SZ00">Szeged</option>
    </b-select>
    &nbsp;
    <b-button
      class="m-1 gomb"
      variant="primary"
      @click="fullExtentClicked"
      :title="
        $store.state.parameterStripe.modelType == 'climate'
          ? 'A 10x10 km-es felbontású adatok átlaga Magyarországra'
          : 'Az 1x1 km-es felbontású adatok átlaga a városra'
      "
      v-b-tooltip.hover
      v-show="
        $store.state.parameterStripe.viewType == 'graphView' &&
        citySelector == 'BPK00'
      "
      :style="felbontas == 'HUM000'"
      >{{
        $store.state.parameterStripe.modelType == "climate"
          ? "Országos"
          : "Budapest"
      }}</b-button
    >&nbsp;
    <multiselect
      v-model="megye"
      :options="megyeLista"
      :taggable="false"
      :searchable="true"
      track-by="id"
      label="name"
      class="alma"
      :showLabels="false"
      :multiple="false"
      placeholder="Válasszon vármegyét"
      v-b-tooltip.hover
      title="A 10x10 km-es felbontású adatok átlaga a kiválasztott megyére"
      v-show="
        $store.state.parameterStripe.modelType == 'climate' &&
        $store.state.parameterStripe.viewType == 'graphView'
      "
      @select="megyeSelect"
      >&nbsp;</multiselect
    >
    <multiselect
      v-model="jaras"
      :options="jarasLista"
      :taggable="false"
      :searchable="true"
      track-by="id"
      label="name"
      class="alma"
      :showLabels="false"
      :multiple="false"
      v-b-tooltip.hover
      title="A 10x10 km-es felbontású adatok átlaga a kiválasztott járásra"
      placeholder="Válasszon járást"
      v-show="
        $store.state.parameterStripe.modelType == 'climate' &&
        $store.state.parameterStripe.viewType == 'graphView'
      "
      @select="jarasSelect"
    ></multiselect>

    <multiselect
      v-model="kerulet"
      :options="keruletLista"
      :taggable="false"
      :searchable="true"
      track-by="id"
      label="name"
      class="alma"
      :showLabels="false"
      :multiple="false"
      v-b-tooltip.hover
      title="Az 1x1 km-es felbontású adatok átlaga a kiválasztott kerületre"
      placeholder="Válasszon kerületet"
      v-show="
        $store.state.parameterStripe.modelType == 'city' &&
        $store.state.parameterStripe.viewType == 'graphView' &&
        citySelector == 'BPK00'
      "
      @select="keruletSelect"
    ></multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import vSelect from "vue-select";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import axios from "axios";
import { config } from "@/config/config.js";
export default {
  name: "AggregationModeSelector",
  components: { Multiselect, vSelect, ModelSelect },
  props: { chosedAggregationMode: String },
  data() {
    return {
      felbontas: "HUM000",
      megye: null,
      jaras: null,
      kerulet: null,
      citySelector: "BPK00",
      filteredMegyeLista: [],
      megyeLista: [
        { id: "001", name: "Győr-Moson-Sopron" },
        { id: "002", name: "Vas" },
        { id: "003", name: "Zala" },
        { id: "004", name: "Veszprém" },
        { id: "005", name: "Somogy" },
        { id: "006", name: "Komárom-Esztergom" },
        { id: "007", name: "Fejér" },
        { id: "008", name: "Tolna" },
        { id: "009", name: "Baranya" },
        { id: "010", name: "Pest" },
        { id: "011", name: "Bács-Kiskun" },
        { id: "012", name: "Nógrád" },
        { id: "013", name: "Heves" },
        { id: "014", name: "Jász-Nagykun-Szolnok" },
        { id: "015", name: "Csongrád-Csanád" },
        { id: "016", name: "Borsod-Abaúj-Zemplén" },
        { id: "017", name: "Szabolcs-Szatmár-Bereg" },
        { id: "018", name: "Hajdú-Bihar" },
        { id: "019", name: "Békés" },
        { id: "020", name: "Budapest" },
      ],
      keruletLista: [
        { id: "00", name: "Budapest" },
        { id: "01", name: "1. kerület" },
        { id: "02", name: "2. kerület" },
        { id: "03", name: "3. kerület" },
        { id: "04", name: "4. kerület" },
        { id: "05", name: "5. kerület" },
        { id: "06", name: "6. kerület" },
        { id: "07", name: "7. kerület" },
        { id: "08", name: "8. kerület" },
        { id: "09", name: "9. kerület" },
        { id: "10", name: "10. kerület" },
        { id: "11", name: "11. kerület" },
        { id: "12", name: "12. kerület" },
        { id: "13", name: "13. kerület" },
        { id: "14", name: "14. kerület" },
        { id: "15", name: "15. kerület" },
        { id: "16", name: "16. kerület" },
        { id: "17", name: "17. kerület" },
        { id: "18", name: "18. kerület" },
        { id: "19", name: "19. kerület" },
        { id: "20", name: "20. kerület" },
        { id: "21", name: "21. kerület" },
        { id: "22", name: "22. kerület" },
        { id: "23", name: "23. kerület" },
      ],
      jarasLista: [
        { id: "001", name: "Mosonmagyaróvári" },
        { id: "002", name: "Soproni" },
        { id: "003", name: "Kapuvári" },
        { id: "004", name: "Csornai" },
        { id: "005", name: "Győri" },
        { id: "006", name: "Téti" },
        { id: "007", name: "Pannonhalmi" },
        { id: "008", name: "Kőszegi" },
        { id: "009", name: "Szombathelyi" },
        { id: "010", name: "Sárvári" },
        { id: "011", name: "Celldömölki" },
        { id: "012", name: "Körmendi" },
        { id: "013", name: "Vasvári" },
        { id: "014", name: "Szentgotthárdi" },
        { id: "015", name: "Zalaszentgróti" },
        { id: "016", name: "Zalaegerszegi" },
        { id: "017", name: "Keszthelyi" },
        { id: "018", name: "Lenti" },
        { id: "019", name: "Letenyei" },
        { id: "020", name: "Nagykanizsai" },
        { id: "021", name: "Pápai" },
        { id: "022", name: "Devecseri" },
        { id: "023", name: "Sümegi" },
        { id: "024", name: "Ajkai" },
        { id: "025", name: "Tapolcai" },
        { id: "026", name: "Zirci" },
        { id: "027", name: "Veszprémi" },
        { id: "028", name: "Balatonfüredi" },
        { id: "029", name: "Várpalotai" },
        { id: "030", name: "Balatonalmádi" },
        { id: "031", name: "Marcali" },
        { id: "032", name: "Fonyódi" },
        { id: "033", name: "Siófoki" },
        { id: "034", name: "Tabi" },
        { id: "035", name: "Kaposvári" },
        { id: "036", name: "Nagyatádi" },
        { id: "037", name: "Csurgói" },
        { id: "038", name: "Barcsi" },
        { id: "039", name: "Komáromi" },
        { id: "040", name: "Kisbéri" },
        { id: "041", name: "Tatai" },
        { id: "042", name: "Oroszlányi" },
        { id: "043", name: "Tatabányai" },
        { id: "044", name: "Esztergomi" },
        { id: "045", name: "Móri" },
        { id: "046", name: "Bicskei" },
        { id: "047", name: "Székesfehérvári" },
        { id: "048", name: "Gárdonyi" },
        { id: "049", name: "Martonvásári" },
        { id: "050", name: "Enyingi" },
        { id: "051", name: "Sárbogárdi" },
        { id: "052", name: "Dunaújvárosi" },
        { id: "053", name: "Tamási" },
        { id: "054", name: "Paksi" },
        { id: "055", name: "Dombóvári" },
        { id: "056", name: "Bonyhádi" },
        { id: "057", name: "Tolnai" },
        { id: "058", name: "Szekszárdi" },
        { id: "059", name: "Hegyháti" },
        { id: "060", name: "Komlói" },
        { id: "061", name: "Pécsváradi" },
        { id: "062", name: "Mohácsi" },
        { id: "063", name: "Szigetvári" },
        { id: "064", name: "Szentlőrinci" },
        { id: "065", name: "Pécsi" },
        { id: "066", name: "Bólyi" },
        { id: "067", name: "Sellyei" },
        { id: "068", name: "Siklósi" },
        { id: "069", name: "Szobi" },
        { id: "070", name: "Szentendrei" },
        { id: "071", name: "Váci" },
        { id: "072", name: "Pilisvörösvári" },
        { id: "073", name: "Dunakeszi" },
        { id: "074", name: "Gödöllői" },
        { id: "075", name: "Budakeszi" },
        { id: "076", name: "Érdi" },
        { id: "077", name: "Vecsési" },
        { id: "078", name: "Nagykátai" },
        { id: "079", name: "Szigetszentmiklósi" },
        { id: "080", name: "Gyáli" },
        { id: "081", name: "Monori" },
        { id: "082", name: "Ráckevei" },
        { id: "083", name: "Dabasi" },
        { id: "084", name: "Ceglédi" },
        { id: "085", name: "Nagykőrősi" },
        { id: "086", name: "Aszódi" },
        { id: "087", name: "Kunszentmiklósi" },
        { id: "088", name: "Kecskeméti" },
        { id: "089", name: "Tiszakécskei" },
        { id: "090", name: "Kalocsai" },
        { id: "091", name: "Kiskőrösi" },
        { id: "092", name: "Kuiskunfélegyházai" },
        { id: "093", name: "Kiskunmajsai" },
        { id: "094", name: "Kiskunhalasi" },
        { id: "095", name: "Jánoshalmi" },
        { id: "096", name: "Bajai" },
        { id: "097", name: "Bácsalmási" },
        { id: "098", name: "Rétsági" },
        { id: "099", name: "Balassagyarmati" },
        { id: "100", name: "Szécsényi" },
        { id: "101", name: "Pásztói" },
        { id: "102", name: "Salgótarjáni" },
        { id: "103", name: "Bátonyterenyei" },
        { id: "104", name: "Pétervásárai" },
        { id: "105", name: "Bélapátfalvai" },
        { id: "106", name: "Egri" },
        { id: "107", name: "Gyöngyösi" },
        { id: "108", name: "Hatvani" },
        { id: "109", name: "Füzesabonyi" },
        { id: "110", name: "Hevesi" },
        { id: "111", name: "Jászberényi" },
        { id: "112", name: "Jászapáti" },
        { id: "113", name: "Szolnoki" },
        { id: "114", name: "Kunhegyesi" },
        { id: "115", name: "Tiszafüredi" },
        { id: "116", name: "Karcagi" },
        { id: "117", name: "Törökszentmiklósi" },
        { id: "118", name: "Mezőtúri" },
        { id: "119", name: "Kunszentmártoni" },
        { id: "120", name: "Csongrádi" },
        { id: "121", name: "Szentesi" },
        { id: "122", name: "Kisteleki" },
        { id: "123", name: "Hódmezővásárhelyi" },
        { id: "124", name: "Mórahalmi" },
        { id: "125", name: "Szegedi" },
        { id: "126", name: "Makói" },
        { id: "127", name: "Ózdi" },
        { id: "128", name: "Putnoki" },
        { id: "129", name: "Kazincbarcikai" },
        { id: "130", name: "Edelényi" },
        { id: "131", name: "Szikszói" },
        { id: "132", name: "Encsi" },
        { id: "133", name: "Gönci" },
        { id: "134", name: "Sátoraljaújhelyi" },
        { id: "135", name: "Sárospataki" },
        { id: "136", name: "Cigándi" },
        { id: "137", name: "Miskolci" },
        { id: "138", name: "Szerencsi" },
        { id: "139", name: "Tokaji" },
        { id: "140", name: "Mezőkövesdi" },
        { id: "141", name: "Tiszaújvárosi" },
        { id: "142", name: "Mezőcsáti" },
        { id: "143", name: "Tiszavasvári" },
        { id: "144", name: "Ibrányi" },
        { id: "145", name: "Kemecsei" },
        { id: "146", name: "Kisvárdai" },
        { id: "147", name: "Záhonyi" },
        { id: "148", name: "Vásárosnaményi" },
        { id: "149", name: "Fehérgyarmati" },
        { id: "150", name: "Nyíregyházi" },
        { id: "151", name: "Baktalórántházai" },
        { id: "152", name: "Mátészalkai" },
        { id: "153", name: "Csengeri" },
        { id: "154", name: "Nyírbátori" },
        { id: "155", name: "Nagykállói" },
        { id: "156", name: "Hajdúnánási" },
        { id: "157", name: "Hajdúböszörményi" },
        { id: "158", name: "Hajdúházi" },
        { id: "159", name: "Nyíradonyi" },
        { id: "160", name: "Debreceni" },
        { id: "161", name: "Derecskei" },
        { id: "162", name: "Hajdúszoboszlói" },
        { id: "163", name: "Püspökladányi" },
        { id: "164", name: "Berettyóújfalui" },
        { id: "165", name: "Balmazújvárosi" },
        { id: "166", name: "Gyomaendrődi" },
        { id: "167", name: "Szeghalmi" },
        { id: "168", name: "Szarvasi" },
        { id: "169", name: "Békési" },
        { id: "170", name: "Sarkadi" },
        { id: "171", name: "Békéscsabai" },
        { id: "172", name: "Gyulai" },
        { id: "173", name: "Orosházi" },
        { id: "174", name: "Mezőkovácsházai" },
      ],
      /*options: [
        { value: "1", text: "aa" + " - " + "1" },
        { value: "2", text: "ab" + " - " + "2" },
        { value: "3", text: "bc" + " - " + "3" },
        { value: "4", text: "cd" + " - " + "4" },
        { value: "5", text: "de" + " - " + "5" },
      ],*/
      /*item: {
        value: "",
        text: "",
      },*/
    };
  },
  beforeMount() {
    this.jarasLista = this.jarasLista.sort((a, b) =>
      a.name.localeCompare(b.name),
    );
    this.megyeLista = this.megyeLista.sort((a, b) =>
      a.name.localeCompare(b.name),
    );
  },
  methods: {
    fullExtentClicked() {
      if (this.$store.state.parameterStripe.modelType == "climate")
        this.felbontas = "HUM000";
      else this.felbontas = "BPK00";
      this.megye = null;
      this.jaras = null;
      this.kerulet = null;
    },
    megyeSelect(selectedMegye, id) {
      this.felbontas = "HUM" + selectedMegye.id;
      this.jaras = null;
      this.kerulet = null;
    },
    jarasSelect(selectedJaras, id) {
      this.felbontas = "HUJ" + selectedJaras.id;
      this.megye = null;
      this.kerulet = null;
    },
    keruletSelect(selectedKerulet, id) {
      this.felbontas = "BPK" + selectedKerulet.id;
      this.megye = null;
      this.jaras = null;
    },
    citySelect(selectedCity) {
      this.felbontas = selectedCity;
      console.log("City select: " + selectedCity);
      this.megye = null;
      this.jaras = null;
      this.kerulet = null;
    },
  },
  watch: {
    felbontas: function () {
      this.$store.state.parameterStripe.felbontas = this.felbontas;
      console.log("Felbontás: " + this.$store.state.parameterStripe.felbontas);
    },
    "$store.state.parameterStripe.modelType": function () {
      if (this.$store.state.parameterStripe.modelType == "climate") {
        this.felbontas = "HUM000";
        console.log(
          "Model type changed to climate - Aggregation selector reset to HUM000",
        );
      } else {
        console.log(
          "Model type changed to city - Aggregation selector reset to BPK00, citySelector to BPK00",
        );
        if (this.$store.state.parameterStripe.baseCitySelect1 == "SZ") {
          this.felbontas = "SZ";
          this.citySelector = "SZ00";
        } else {
          this.felbontas = "BPK00";
          this.citySelector = "BPK00";
        }
      }
      this.megye = null;
      this.jaras = null;
      this.kerulet = null;
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="vue-select/dist/vue-select.css"></style>
<style>
#container {
  display: flex;
}
.gomb {
  font-size: 1.25rem !important;
}

.alma {
  width: 200px;
  height: 30.75px;
  transform: scale(0.76875);

  margin-left: -10px;
  margin-right: -15px;
}

.fullButton {
  background-color: #28a745;
  border-color: #28a745;
  color: white;
  font-size: 1.25rem;
}
button:hover {
  background-color: #28a745;
  border-color: #28a745;
}
button:focus {
  background-color: #28a745;
  border-color: #28a745;
}
.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
  background-color: #28a745;
  border-color: #28a745;
}
.tooltip-inner {
  background-color: white !important;
  color: black !important;
  border: 1px solid;
  border-color: black;
  font-size: 1.25em;
}
.city-select {
  width: 85px !important;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  font-size: 1.25rem;
}
</style>
